function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;

        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
            return Promise.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return Promise.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new Promise(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var regenerator = runtime_1;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var sleepTimeout = null;
var script = {
  name: 'Splash',
  data: function data() {
    return {
      secretAdminClicksCounter: 0,
      secretAdminClickStartTime: 0,
      secretAdminClickMaxTime: 3000,
      secretBleClicksCounter: 0,
      isLocationSettingsValid: true,
      deviceName: ''
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var _this = this;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.$xp.screen.setOrientation();
              this.$xp.screen.preventSleep();
              sleepTimeout = setTimeout(function () {
                _this.$xp.screen.allowSleep();
              }, this.$xp.settings.mergedSettings.screen.standbySeconds * 1000);
              _context.next = 5;
              return this.checkLocationSettings();

            case 5:
              this.getDeviceName();
              this.$el.querySelector('#start-xpedeo').focus();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    checkLocationSettings: function () {
      var _checkLocationSettings = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.$xp.settings.mergedSettings.showLocationSettingsWarning) {
                  _context2.next = 10;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return this.$xp.device.checkLocationSettings();

              case 4:
                this.isLocationSettingsValid = true;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);
                this.isLocationSettingsValid = false;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 7]]);
      }));

      function checkLocationSettings() {
        return _checkLocationSettings.apply(this, arguments);
      }

      return checkLocationSettings;
    }(),
    getDeviceName: function getDeviceName() {
      var _this2 = this;

      if (this.$xp.device.isLoan) {
        window.XpedeoPreloader.getDeviceName(function (name) {
          _this2.deviceName = name;
        }, function (error) {
          console.log('Error getting device name.');
          console.log(error);
        });
      }
    },
    onSecretAdminClick: function onSecretAdminClick() {
      var now = new Date().getTime();

      if (now - this.secretAdminClickStartTime > this.secretAdminClickMaxTime) {
        this.secretAdminClicksCounter = 1;
        this.secretAdminClickStartTime = now;
      } else {
        this.secretAdminClicksCounter++;
        console.log('admin click');

        if (this.secretAdminClicksCounter >= 5) {
          this.secretAdminClicksCounter = 0; // go to AdminActivity

          this.$xp.device.goToAdminActivity();
        }
      }
    },
    onForwardClick: function onForwardClick() {
      this.$router.push('/page/' + this.$xp.settings.mergedSettings.content.startPageID);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(sleepTimeout);
    this.$xp.screen.preventSleep();
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "c-splash",
      on: {
        touchstart: function($event) {
          if (
            $event.ctrlKey ||
            $event.shiftKey ||
            $event.altKey ||
            $event.metaKey
          ) {
            return null
          }
          return _vm.onSecretAdminClick($event)
        }
      }
    },
    [
      _c("h1", { staticClass: "sr-only" }, [
        _vm._v(_vm._s(_vm.$t("global.xpSplashHeading")))
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.$xp.settings.mergedSettings.showDeviceName
        ? _c("div", { staticClass: "c-splash__device-name" }, [
            _vm._v("\n        " + _vm._s(_vm.deviceName) + "\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "c-splash__button",
          attrs: { id: "start-xpedeo", title: "Xpedeo starten", autofocus: "" },
          on: {
            click: function($event) {
              $event.stopPropagation();
              return _vm.onForwardClick($event)
            }
          }
        },
        [
          _c("img", {
            attrs: {
              alt: "",
              src:
                "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMC8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiBpZD0ieHBlZGVvIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB3aWR0aD0iOTYwcHgiIGhlaWdodD0iOTYwcHgiIHZpZXdCb3g9IjEwMS40MjQgMTIyLjE1NyA5NjAgOTYwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDEwMS40MjQgMTIyLjE1NyA5NjAgOTYwIgoJIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cmFkaWFsR3JhZGllbnQgaWQ9IlNWR0lEXzFfIiBjeD0iNTgxLjQ3ODgiIGN5PSI1OTcuNzAxOSIgcj0iNDgwIiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIC0wLjA1NTIgMTE5OS44NTg5KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgoJPHN0b3AgIG9mZnNldD0iMCIgc3R5bGU9InN0b3AtY29sb3I6I0ZGQTAwMCIvPgoJPHN0b3AgIG9mZnNldD0iMSIgc3R5bGU9InN0b3AtY29sb3I6I0ZGNkUwMCIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8cmVjdCB4PSIxMDEuNDI0IiB5PSIxMjIuMTU3IiBmaWxsPSJ1cmwoI1NWR0lEXzFfKSIgd2lkdGg9Ijk2MCIgaGVpZ2h0PSI5NjAiLz4KPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTg5My41NTksNTY5LjUzNEw2NzAuNzU0LDM1NC40MjljLTE2LjkyNS0xNi4zNTUtNDMuODgzLTE1Ljg2My02MC4yMDksMS4wNTkKCWMtMTYuMzI3LDE2LjkxOC0xNS44NTYsNDMuODY3LDEuMDY2LDYwLjIwM2wxNDYuOTM1LDE0MS44NTVsLTQ1OS42NjUtMC4yOTNjLTAuMDI4LDAtMC4wMjgsMC0wLjAyOCwwCgljLTIzLjUwNywwLTQyLjU3OSwxOS4wNDMtNDIuNTc5LDQyLjU1MWMtMC4wMjcsMjMuNTE2LDE5LjAzLDQyLjU5NCw0Mi41NTMsNDIuNjA4bDQ2Mi40MzcsMC4yOThMNjE0Ljg1NSw3ODkuMTU5CgljLTE2LjYxOCwxNi42MzQtMTYuNjE4LDQzLjU5MSwwLjAxNCw2MC4yMTZjOC4zMTYsOC4zMTUsMTkuMjEsMTIuNDY5LDMwLjEwNSwxMi40NjljMTAuODk1LDAsMjEuNzg5LTQuMTYsMzAuMTA0LTEyLjQ3OAoJTDg5NC4xLDYzMC4yNjljOC4wNjYtOC4wNzgsMTIuNTU4LTE5LjA2MiwxMi40NzQtMzAuNDg0QzkwNi40NjMsNTg4LjM2Miw5MDEuNzc5LDU3Ny40NjksODkzLjU1OSw1NjkuNTM0eiIvPgo8L3N2Zz4K"
            }
          })
        ]
      ),
      _vm._v(" "),
      !_vm.isLocationSettingsValid
        ? _c("i", {
            staticClass:
              "xp xp--large xp-map-marker location-settings-warning animated flash"
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "bg-tr",
          attrs: {
            id: "bg-tr-bottomleft",
            width: "320px",
            height: "320px",
            viewBox: "0 0 320 320"
          }
        },
        [
          _c("polygon", {
            attrs: {
              fill: "url(#bg-triangle)",
              points: "0,0 320,320 0,320 ",
              opacity: "0.25"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "bg-tr",
          attrs: {
            id: "bg-tr-bottomright",
            width: "320px",
            height: "320px",
            viewBox: "0 0 320 320"
          }
        },
        [
          _c("polygon", {
            attrs: {
              fill: "url(#bg-triangle)",
              points: "0,320 320,320 320,0 ",
              opacity: "0.25"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "bg-tr",
          attrs: {
            id: "bg-tr-topright",
            width: "320px",
            height: "320px",
            viewBox: "0 0 320 320"
          }
        },
        [
          _c("polygon", {
            attrs: {
              fill: "url(#bg-triangle)",
              points: "0,0 320,0 320,320 ",
              opacity: "0.25"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("svg", { attrs: { id: "defs" } }, [
        _c(
          "defs",
          [
            _c(
              "filter",
              { attrs: { id: "dropshadow", height: "130%" } },
              [
                _c("feGaussianBlur", {
                  attrs: { in: "SourceAlpha", stdDeviation: "2" }
                }),
                _vm._v(" "),
                _c("feOffset", {
                  attrs: { dx: "2", dy: "2", result: "offsetblur" }
                }),
                _vm._v(" "),
                _c(
                  "feComponentTransfer",
                  [_c("feFuncA", { attrs: { type: "linear", slope: "0.5" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "feMerge",
                  [
                    _c("feMergeNode"),
                    _vm._v(" "),
                    _c("feMergeNode", { attrs: { in: "SourceGraphic" } })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "radialGradient",
              {
                attrs: {
                  id: "grey",
                  cx: "-50",
                  cy: "100",
                  r: "300",
                  gradientUnits: "userSpaceOnUse"
                }
              },
              [
                _c("stop", {
                  attrs: { offset: "0", "stop-color": "var(--color-stop-1)" }
                }),
                _c("stop", {
                  attrs: { offset: "1", "stop-color": "var(--color-stop-2)" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "radialGradient",
              {
                attrs: {
                  id: "bg-triangle",
                  cx: "-50",
                  cy: "100",
                  r: "300",
                  gradientUnits: "userSpaceOnUse"
                }
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#C5C6C6" },
                  attrs: { offset: "0" }
                }),
                _vm._v(" "),
                _c("stop", {
                  staticStyle: { "stop-color": "#9C9C9C" },
                  attrs: { offset: "1" }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
};
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "c-splash__logo" }, [
      _c("img", {
        attrs: {
          alt: "Xpedeo logo",
          src:
            "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMC8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiBpZD0ieHBlZGVvIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB3aWR0aD0iMjUyMHB4IiBoZWlnaHQ9IjEyMDBweCIgdmlld0JveD0iMCAwIDI1MjAgMTIwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjUyMCAxMjAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGZvbnQgaG9yaXotYWR2LXg9IjEwMDAiPgo8IS0tIFNvdXJjZSBpcyBhIHRyYWRlbWFyayBvZiBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZCBpbiB0aGUgVW5pdGVkIFN0YXRlcyBhbmQvb3Igb3RoZXIgY291bnRyaWVzLiAtLT4KPGZvbnQtZmFjZSBmb250LWZhbWlseT0iU291cmNlU2Fuc1Byby1FeHRyYUxpZ2h0SXRhbGljIiB1bml0cy1wZXItZW09IjEwMDAiIHVuZGVybGluZS1wb3NpdGlvbj0iLTc1IiB1bmRlcmxpbmUtdGhpY2tuZXNzPSI1MCIvPgo8bWlzc2luZy1nbHlwaCBob3Jpei1hZHYteD0iNjAwIiBkPSJNNDIsMGwxMzAsNjYwbDQxNiwwbC0xMzAsLTY2ME0zMjAsMzY0bDQsMGw3Miw5MmwxMjYsMTcybC0yOTIsMGw1NiwtMTcyTTk2LDMybDMxOCwwbC02MCwxNzZsLTQwLDEwNGwtNCwwbC04MiwtMTA0TTk2LDcybDE5OCwyNjhsLTkyLDI3ME00MzQsNzJsMTEwLDUzOGwtMjAyLC0yNzB6Ii8+CjxnbHlwaCB1bmljb2RlPSJkIiBob3Jpei1hZHYteD0iNTI2IiBkPSJNNDM2LDQxMGwyMCw5Nmw0NCwyMTZsMjgsMGwtMTQ2LC03MjJsLTI0LDBsMTIsNzhsLTQsMEMzNDEsNTIgMzEzLDMxIDI4MywxNEMyNTIsLTMgMjIwLC0xMiAxODYsLTEyQzE0NCwtMTIgMTEwLDMgODUsMzJDNTksNjEgNDYsMTAzIDQ2LDE2MEM0NiwyMDYgNTMsMjQ5IDY4LDI4OUM4MywzMjkgMTAyLDM2NCAxMjcsMzk0QzE1MSw0MjQgMTc5LDQ0OCAyMTAsNDY1QzI0MSw0ODIgMjczLDQ5MCAzMDYsNDkwQzMzNSw0OTAgMzYwLDQ4MyAzODEsNDY4QzQwMiw0NTMgNDE5LDQzNCA0MzIsNDEwTTE4OCwxNEMyMjEsMTQgMjU0LDI0IDI4Niw0M0MzMTcsNjIgMzQ4LDg4IDM3OCwxMjJsNTIsMjUwQzQxMSw0MDUgMzkxLDQyOSAzNzEsNDQzQzM1MCw0NTcgMzI4LDQ2NCAzMDQsNDY0QzI3NCw0NjQgMjQ1LDQ1NSAyMTgsNDM4QzE5MCw0MjEgMTY1LDM5OCAxNDQsMzcwQzEyMywzNDIgMTA2LDMxMCA5MywyNzVDODAsMjM5IDc0LDIwMyA3NCwxNjZDNzQsMTE1IDg0LDc3IDEwNSw1MkMxMjUsMjcgMTUzLDE0IDE4OCwxNHoiLz4KPGdseXBoIHVuaWNvZGU9ImUiIGhvcml6LWFkdi14PSI0NjgiIGQ9Ik00NCwxODRDNDQsMjI5IDUxLDI3MSA2NiwzMDlDODAsMzQ2IDk5LDM3OSAxMjIsNDA2QzE0NSw0MzMgMTcxLDQ1MyAyMDAsNDY4QzIyOSw0ODMgMjU5LDQ5MCAyOTAsNDkwQzMxNSw0OTAgMzM3LDQ4NiAzNTUsNDc4QzM3Myw0NjkgMzg4LDQ1OCAzOTksNDQzQzQxMCw0MjggNDE5LDQxMCA0MjQsMzkwQzQyOSwzNjkgNDMyLDM0NyA0MzIsMzIyQzQzMiwzMDYgNDMxLDI5MSA0MjksMjc4QzQyNiwyNjQgNDIzLDI1MiA0MjAsMjQybC0zNDIsMEM3MSwyMDIgNzAsMTY4IDc1LDEzOUM4MCwxMTAgOTAsODcgMTA0LDY4QzExOCw0OSAxMzYsMzYgMTU3LDI3QzE3OCwxOCAyMDEsMTQgMjI2LDE0QzI0OCwxNCAyNzAsMTkgMjkxLDI4QzMxMiwzNyAzMzIsNDkgMzUwLDYybDE0LC0yMkMzNDUsMjYgMzIzLDE0IDI5OSw0QzI3NSwtNyAyNTAsLTEyIDIyNCwtMTJDMTY5LC0xMiAxMjUsNSA5MywzOEM2MCw3MSA0NCwxMTkgNDQsMTg0TTg0LDI2OGwzMTQsMEM0MDAsMjc4IDQwMiwyODggNDAzLDI5N0M0MDQsMzA2IDQwNCwzMTcgNDA0LDMyOEM0MDQsMzQ1IDQwMiwzNjEgMzk4LDM3OEMzOTQsMzk0IDM4OCw0MDkgMzc5LDQyMkMzNzAsNDM1IDM1OCw0NDUgMzQzLDQ1M0MzMjgsNDYwIDMwOSw0NjQgMjg4LDQ2NEMyNjUsNDY0IDI0Myw0NTkgMjIyLDQ1MEMyMDAsNDQwIDE4MCw0MjYgMTYyLDQwOUMxNDQsMzkyIDEyOCwzNzEgMTE1LDM0N0MxMDEsMzIzIDkxLDI5NyA4NCwyNjh6Ii8+CjxnbHlwaCB1bmljb2RlPSJvIiBob3Jpei1hZHYteD0iNTAwIiBkPSJNMjA0LC0xMkMxNTYsLTEyIDExOCw0IDg5LDM3QzYwLDY5IDQ2LDExNSA0NiwxNzZDNDYsMjIxIDUzLDI2MiA2NywzMDFDODEsMzM5IDEwMCwzNzIgMTIzLDQwMEMxNDYsNDI4IDE3Miw0NTAgMjAyLDQ2NkMyMzIsNDgyIDI2Myw0OTAgMjk2LDQ5MEMzNDQsNDkwIDM4Miw0NzQgNDExLDQ0MkM0NDAsNDA5IDQ1NCwzNjMgNDU0LDMwMkM0NTQsMjU3IDQ0NywyMTYgNDMzLDE3OEM0MTksMTM5IDQwMSwxMDYgMzc4LDc4QzM1NSw1MCAzMjgsMjggMjk4LDEyQzI2OCwtNCAyMzcsLTEyIDIwNCwtMTJNMjA2LDE0QzIzMywxNCAyNTksMjIgMjg2LDM3QzMxMiw1MiAzMzYsNzIgMzU3LDk4QzM3OCwxMjQgMzk0LDE1NCA0MDcsMTg4QzQyMCwyMjIgNDI2LDI1OCA0MjYsMjk2QzQyNiwzNTEgNDE1LDM5MyAzOTIsNDIyQzM2OSw0NTAgMzM2LDQ2NCAyOTQsNDY0QzI2Nyw0NjQgMjQwLDQ1NyAyMTQsNDQyQzE4OCw0MjcgMTY1LDQwNiAxNDQsMzgwQzEyMywzNTQgMTA2LDMyNCA5MywyOTBDODAsMjU2IDc0LDIyMCA3NCwxODJDNzQsMTI3IDg2LDg1IDEwOSw1N0MxMzIsMjggMTY0LDE0IDIwNiwxNHoiLz4KPGdseXBoIHVuaWNvZGU9InAiIGhvcml6LWFkdi14PSI1MjAiIGQ9Ik04NCw2OGwtMjIsLTExMGwtMzQsLTE4MGwtMjgsMGwxNDAsNzAwbDI0LDBsLTEyLC03MGw0LDBDMTgyLDQyOSAyMTAsNDQ4IDI0MCw0NjVDMjcwLDQ4MiAzMDIsNDkwIDMzNiw0OTBDMzc4LDQ5MCA0MTIsNDc1IDQzOCw0NDZDNDYzLDQxNyA0NzYsMzc0IDQ3NiwzMThDNDc2LDI3MiA0NjksMjI5IDQ1NCwxODlDNDM5LDE0OSA0MjAsMTE0IDM5Niw4NEMzNzEsNTQgMzQzLDMxIDMxMiwxNEMyODEsLTMgMjQ5LC0xMiAyMTYsLTEyQzE4NywtMTIgMTYxLC00IDE0MCwxMUMxMTgsMjYgMTAwLDQ1IDg2LDY4TTMzNCw0NjRDMzIwLDQ2NCAzMDUsNDYyIDI4OSw0NTdDMjczLDQ1MiAyNTcsNDQ2IDI0MSw0MzhDMjI0LDQyOSAyMDgsNDE5IDE5Miw0MDhDMTc2LDM5NiAxNjEsMzgzIDE0NiwzNzBsLTU0LC0yNjhDMTExLDcwIDEzMSw0NyAxNTIsMzRDMTcyLDIxIDE5NCwxNCAyMTgsMTRDMjQ4LDE0IDI3NywyMyAzMDUsNDBDMzMyLDU3IDM1Nyw3OSAzNzgsMTA3QzM5OSwxMzUgNDE2LDE2NyA0MjksMjAzQzQ0MiwyMzggNDQ4LDI3NSA0NDgsMzEyQzQ0OCwzNjMgNDM4LDQwMSA0MTgsNDI2QzM5Nyw0NTEgMzY5LDQ2NCAzMzQsNDY0eiIvPgo8L2ZvbnQ+CgoJPGZvbnQgaG9yaXotYWR2LXg9IjEwMDAiPgo8IS0tIFNvdXJjZSBpcyBhIHRyYWRlbWFyayBvZiBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZCBpbiB0aGUgVW5pdGVkIFN0YXRlcyBhbmQvb3Igb3RoZXIgY291bnRyaWVzLiAtLT4KPGZvbnQtZmFjZSBmb250LWZhbWlseT0iU291cmNlU2Fuc1Byby1CbGFja0l0YWxpYyIgdW5pdHMtcGVyLWVtPSIxMDAwIiB1bmRlcmxpbmUtcG9zaXRpb249Ii03NSIgdW5kZXJsaW5lLXRoaWNrbmVzcz0iNTAiLz4KPG1pc3NpbmctZ2x5cGggaG9yaXotYWR2LXg9IjY3NiIgZD0iTTI2LDBsMTMwLDY2MGw1MjQsMGwtMTMwLC02NjBNMzcwLDQxOGw0LDBsNTgsOTZsMjgsNDhsLTEyMiwwbDEyLC00OE0yNDIsOThsMTMwLDBsLTE0LDY2bC0xNiw5NmwtNCwwbC01NCwtOTZNMTYyLDE2MmwxMTgsMTc4bC00NiwxNzZNNDc4LDE2Mmw3MiwzNTRsLTExOCwtMTc2eiIvPgo8Z2x5cGggdW5pY29kZT0ieCIgaG9yaXotYWR2LXg9IjUxNCIgZD0iTS0zOCwwbDIwNiwyNjhsLTg0LDIzMmwxNjIsMGwyNSwtNzdDMjc0LDQwOSAyNzgsMzk1IDI4MiwzODFDMjg2LDM2NiAyOTAsMzUyIDI5MywzMzhsNCwwQzMwNCwzNTIgMzEyLDM2NiAzMjEsMzgxQzMyOSwzOTUgMzM3LDQwOSAzNDQsNDIzbDM4LDc3bDE3MCwwbC0xOTIsLTI2OGw5MCwtMjMybC0xNjQsMGwtMjYsNzZDMjU1LDkwIDI1MSwxMDQgMjQ3LDExOUMyNDMsMTM0IDIzOSwxNDggMjM0LDE2MmwtNCwwQzIyMiwxNDggMjE0LDEzNCAyMDUsMTIwQzE5NiwxMDUgMTg4LDkxIDE3OSw3NmwtNDYsLTc2eiIvPgo8L2ZvbnQ+CgoJPGc+Cgk8cmFkaWFsR3JhZGllbnQgaWQ9IlNWR0lEXzFfIiBjeD0iNjUyLjYxNzIiIGN5PSI1NjEuMjc5MyIgcj0iMzUxLjE0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CgkJPHN0b3AgIG9mZnNldD0iMCIgc3R5bGU9InN0b3AtY29sb3I6I0ZGQTAwMCIvPgoJCTxzdG9wICBvZmZzZXQ9IjEiIHN0eWxlPSJzdG9wLWNvbG9yOiNGRjZFMDAiLz4KCTwvcmFkaWFsR3JhZGllbnQ+Cgk8cG9seWdvbiBmaWxsPSJ1cmwoI1NWR0lEXzFfKSIgcG9pbnRzPSI4NDAsNjAwIDM2MCw2MDAgMzYwLDEyMCAJIi8+CgkKCQk8cmFkaWFsR3JhZGllbnQgaWQ9IlNWR0lEXzJfIiBjeD0iODE4Ny4xMTgyIiBjeT0iLTI5OTkuNzM0OSIgcj0iMzQ3Ljk5NiIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgLTEgODUyMCAtMjQwMCkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KCQk8c3RvcCAgb2Zmc2V0PSIwIiBzdHlsZT0ic3RvcC1jb2xvcjojRkZBMDAwIi8+CgkJPHN0b3AgIG9mZnNldD0iMSIgc3R5bGU9InN0b3AtY29sb3I6I0ZGNkUwMCIvPgoJPC9yYWRpYWxHcmFkaWVudD4KCTxwb2x5Z29uIGZpbGw9InVybCgjU1ZHSURfMl8pIiBwb2ludHM9IjM2MCw2MDAgMzYwLDg0MCAxMjAsODQwIAkiLz4KCQoJCTxyYWRpYWxHcmFkaWVudCBpZD0iU1ZHSURfM18iIGN4PSI0NTAuNzg3NiIgY3k9Ijc3Ny45NDg3IiByPSIyNjIuNzA0OCIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAxIDE0NC44NTM1IDYwLjAwMTUpIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CgkJPHN0b3AgIG9mZnNldD0iMCIgc3R5bGU9InN0b3AtY29sb3I6I0ZGQTAwMCIvPgoJCTxzdG9wICBvZmZzZXQ9IjEiIHN0eWxlPSJzdG9wLWNvbG9yOiNGRjZFMDAiLz4KCTwvcmFkaWFsR3JhZGllbnQ+Cgk8cG9seWdvbiBmaWxsPSJ1cmwoI1NWR0lEXzNfKSIgcG9pbnRzPSIzNjAuMDAxLDkzOS40MSAzNjAsNjAwIDY5OS40MTEsNjAwIAkiLz4KCQoJCTxyYWRpYWxHcmFkaWVudCBpZD0iU1ZHSURfNF8iIGN4PSI1MjkuNDk3NiIgY3k9Ii0yNzExLjkwMzYiIHI9IjI3NC44MDAzIiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KDAuNzA3MSAtMC43MDcxIDAuNzA3MSAwLjcwNzEgMjUwNi40OTA1IDI3MzkuMzYxOCkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KCQk8c3RvcCAgb2Zmc2V0PSIwIiBzdHlsZT0ic3RvcC1jb2xvcjojRkZBMDAwIi8+CgkJPHN0b3AgIG9mZnNldD0iMSIgc3R5bGU9InN0b3AtY29sb3I6I0ZGNkUwMCIvPgoJPC9yYWRpYWxHcmFkaWVudD4KCTxwb2x5Z29uIGZpbGw9InVybCgjU1ZHSURfNF8pIiBwb2ludHM9IjEwMDkuNzA1LDQzMC4yOTUgODQwLDYwMCA2NzAuMjkzLDQzMC4yOTQgCSIvPgo8L2c+Cjx0ZXh0IHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIDEgOTcyIDg0MCkiIGRpc3BsYXk9Im5vbmUiPjx0c3BhbiB4PSIwIiB5PSIwIiBkaXNwbGF5PSJpbmxpbmUiIGZvbnQtZmFtaWx5PSInU291cmNlU2Fuc1Byby1CbGFja0l0YWxpYyciIGZvbnQtc2l6ZT0iNDgwIiBsZXR0ZXItc3BhY2luZz0iLTQiPng8L3RzcGFuPjx0c3BhbiB4PSIyNDEuOTE3IiB5PSIwIiBkaXNwbGF5PSJpbmxpbmUiIGZvbnQtZmFtaWx5PSInU291cmNlU2Fuc1Byby1FeHRyYUxpZ2h0SXRhbGljJyIgZm9udC1zaXplPSI0ODAiIGxldHRlci1zcGFjaW5nPSItMiI+cDwvdHNwYW4+PHRzcGFuIHg9IjQ4OS4xMTEiIHk9IjAiIGRpc3BsYXk9ImlubGluZSIgZm9udC1mYW1pbHk9IidTb3VyY2VTYW5zUHJvLUV4dHJhTGlnaHRJdGFsaWMnIiBmb250LXNpemU9IjQ4MCIgbGV0dGVyLXNwYWNpbmc9Ii0xMSI+ZWRlbzwvdHNwYW4+PC90ZXh0Pgo8ZyBkaXNwbGF5PSJub25lIj4KCTxwb2x5Z29uIGRpc3BsYXk9ImlubGluZSIgZmlsbD0iI0NBQkI5RiIgcG9pbnRzPSI4NDAuMDAyLDU5OS45OTggMzU5Ljk5Niw1OTkuOTk4IDM1OS45OTYsMTIwIAkiLz4KCTxwb2x5Z29uIGRpc3BsYXk9ImlubGluZSIgZmlsbD0iI0NBQkI5RiIgcG9pbnRzPSIzNTkuOTk2LDU5OS45OTggMzU5Ljk5Niw4NDAuMDAxIDEyMCw4NDAuMDAxIAkiLz4KCTxwb2x5Z29uIGRpc3BsYXk9ImlubGluZSIgZmlsbD0iI0NBQkI5RiIgcG9pbnRzPSIzNTkuOTk2LDkzOS40MSAzNTkuOTk2LDU5OS45OTggNjk5LjQwOCw1OTkuOTk4IAkiLz4KCTxwb2x5Z29uIGRpc3BsYXk9ImlubGluZSIgZmlsbD0iI0NBQkI5RiIgcG9pbnRzPSIxMDA5LjcwNyw0MzAuMjkyIDg0MC4wMDIsNTk5Ljk5OCA2NzAuMjk1LDQzMC4yOTIgCSIvPgo8L2c+CjxnPgoJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTEwMjIuMTg2LDgyOS4yMjhoLTYwLjAxMmw4Ny44NzYtMTE0LjQxN2wtMzYuODYxLTEwMy42MThoNjcuNzI2bDE4LDY2LjA1NWw1MC4xNTUtNjYuMDU1aDYwLjQ0MgoJCUwxMTI5Ljc4LDcxNS42N2wzOC4xNDksMTEzLjU1N2gtNjguMTU1bC0yMS40MzEtNzYuNDI0TDEwMjIuMTg2LDgyOS4yMjh6Ii8+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMTI4OC4wMDEsNjM3LjUyN2wxLjI5MS0wLjQzYzE4LTIxLjE1OCw0MS4xNTItMzAuMjI5LDU4LjMtMzAuMjI5YzY3LjcyNiwwLDU1LjcxOSw1OS41OSw0OS43MjUsODguMDgzCgkJbC0xMC4yOTMsNDguNzkxYy0xMS45OTgsNTYuNTU2LTM4LjE1MSw4OS44MDMtOTMuNDQ5LDg5LjgwM2MtMTUuODU4LDAtMzAuMDA2LTcuNzcyLTM5LjAwMS0yOC40OTRsLTAuODYtMC40MjhsLTIyLjcyMiwxMDcuMDc0CgkJaC0yNS43MTNsNjMuNDM0LTMwMC41MDJoMjQuODYyTDEyODguMDAxLDYzNy41Mjd6IE0xMjY3LjQzMSw3MzkuNDE4Yy0xMC4yODcsNDkuNjU5LDYuODU0LDczLjQwNCwzMC40MzUsNzMuNDA0CgkJYzQyLjQzNCwwLDU2LjU4LTM1LjgzNCw2OC41ODUtOTIuODI3YzExLjk5OC01Ni41NjIsMTIuODU3LTkyLjM5OS0yOS41NzYtOTIuMzk5Yy0xNi43MTgsMC00OS43MjUsMTguOTkzLTYxLjMsNzIuOTY4CgkJTDEyNjcuNDMxLDczOS40MTh6Ii8+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMTQ3NS43OTgsNzI1LjYwOGwtMy40MzEsMTYuODM1Yy02LjQyNSwzMC4yMTktNi44NTQsNzAuMzc4LDMzLjg2Nyw3MC4zNzgKCQljMzIuMTQ2LDAsNTIuMjk3LTIwLjcyOCw1OC4zLTUwLjA4OWgyNy4wMDRjLTE0LjE0Niw1Mi42NzgtNDYuMjk0LDcwLjgxMS04OS41ODYsNzAuODExYy0zNy4yOTksMC03MS41ODctMTUuMTA2LTU3LjQ0LTgxLjE3CgkJbDExLjE0Ni01My41MzdjMTMuMjg4LTYzLjAzOCw0NS40MzUtOTEuOTY5LDkzLjg2OS05MS45NjljNzQuNTg4LDAsNjMuNDQzLDUzLjk3NSw0OS43MjcsMTE4Ljc0SDE0NzUuNzk4eiBNMTU3Ny44Miw3MDQuODgKCQljMTAuMjg3LTQ4LjM2LDguNTc1LTc3LjI4NC0zMi41NzctNzcuMjg0cy01NC44NjgsMjguOTI0LTY1LjE1Myw3Ny4yODRIMTU3Ny44MnoiLz4KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0xNzY1LjE4LDgwMS41OTRsLTEuMjkxLDAuNDNjLTE3LjU3LDIwLjcyOS0zNi4wMDcsMzEuNTItNjEuMjkyLDMxLjUyCgkJYy02Mi41OTEsMC01Mi43MjgtNjIuNjA3LTQyLjAxMi0xMTMuNTQ5YzguNTc1LTQxLjg4NywyMy41NzMtMTEzLjEyNyw5MC4wMTgtMTEzLjEyN2MxOS43MTksMCwzNy4yOTcsOS4wNzEsNDcuMTUzLDI1LjkwNAoJCWwwLjg2LDAuNDM5bDI0LjAwMy0xMTUuNzE0aDI1LjcyMmwtNTYuNTg4LDI2OC41NTRjLTQuMjgzLDIxLjU4OC02LjAwMywzNS44MzQtNi40MjUsNDMuMTc3aC0yNC44NjFMMTc2NS4xOCw4MDEuNTk0egoJCSBNMTc3Ni43NTYsNzM5Ljg1NGw4LjE0NC0zOC44NmMzLjAwMi0xMi45NTYsMTUuNDI5LTczLjM5OC0zMy4wMDctNzMuMzk4Yy00Ni4yOTQsMC01NS4yOTgsNDIuMzEtNjYuMDE0LDkzLjI1OQoJCWMtMTcuMTQ4LDgxLjE2OSwwLDkxLjk2NywyNy44NjQsOTEuOTY3QzE3MzguMTc2LDgxMi44MjIsMTc2NS42MSw3OTIuOTYzLDE3NzYuNzU2LDczOS44NTR6Ii8+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMTg5OS4zODMsNzI1LjYwOGwtMy40MzEsMTYuODM1Yy02LjQyNSwzMC4yMTktNi44NTUsNzAuMzc4LDMzLjg2Niw3MC4zNzgKCQljMzIuMTQ2LDAsNTIuMjk2LTIwLjcyOCw1OC4yOTktNTAuMDg5aDI3LjAwNWMtMTQuMTQ4LDUyLjY3OC00Ni4yOTQsNzAuODExLTg5LjU4OCw3MC44MTFjLTM3LjI5NywwLTcxLjU4Ni0xNS4xMDYtNTcuNDM5LTgxLjE3CgkJbDExLjE0Ni01My41MzdjMTMuMjg4LTYzLjAzOCw0NS40MzQtOTEuOTY5LDkzLjg3LTkxLjk2OWM3NC41ODksMCw2My40NDMsNTMuOTc1LDQ5LjcyNSwxMTguNzRIMTg5OS4zODN6IE0yMDAxLjQwNSw3MDQuODgKCQljMTAuMjg2LTQ4LjM2LDguNTczLTc3LjI4NC0zMi41NzctNzcuMjg0Yy00MS4xNTEsMC01NC44NjksMjguOTI0LTY1LjE1NCw3Ny4yODRIMjAwMS40MDV6Ii8+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMjA4MS42MDYsNzQzLjc0MWw5Ljg1Ny00Ny4wNjNjMTIuMDA0LTU2LjU2Miw0Mi44Ny04OS44MSw5My40NDYtODkuODEKCQljNTAuNTg2LDAsNjcuNzM0LDMzLjI0Nyw1NS43MjksODkuODFsLTkuODU1LDQ3LjA2M2MtMTIuMDA2LDU2LjU1Ni00Mi44NzEsODkuODAzLTkzLjQ0OSw4OS44MDMKCQlDMjA4Ni43NDksODMzLjU0NCwyMDY5LjYwMSw4MDAuMjk3LDIwODEuNjA2LDc0My43NDF6IE0yMTEyLjQ3Myw3MTkuOTk1Yy0xMi4wMDYsNTYuOTkzLTEzLjI4OCw5Mi44MjcsMjkuMTQ2LDkyLjgyNwoJCWM0Mi40NCwwLDU2LjU4LTM1LjgzNCw2OC41ODYtOTIuODI3YzEyLjAwNC01Ni41NjIsMTIuODU1LTkyLjM5OS0yOS41NzYtOTIuMzk5CgkJQzIxMzguMTg3LDYyNy41OTYsMjEyNC40Nyw2NjMuNDMzLDIxMTIuNDczLDcxOS45OTV6Ii8+CjwvZz4KPC9zdmc+Cg=="
        }
      })
    ])
  }
];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
